var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalChannelFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#00205A",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.9075C25.34 18.9075 25.67 18.9475 26 18.9975V15.4875C26 14.6875 25.53 13.9675 24.8 13.6575L19.3 11.2575C18.79 11.0375 18.21 11.0375 17.7 11.2575L12.2 13.6575C11.47 13.9775 11 14.6975 11 15.4875V19.0875C11 23.6275 14.2 27.8775 18.5 28.9075C19.05 28.7775 19.58 28.5875 20.1 28.3575C19.41 27.3775 19 26.1875 19 24.9075C19 21.5975 21.69 18.9075 25 18.9075Z",
    fill: "#00205A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.9075C22.79 20.9075 21 22.6975 21 24.9075C21 27.1175 22.79 28.9075 25 28.9075C27.21 28.9075 29 27.1175 29 24.9075C29 22.6975 27.21 20.9075 25 20.9075ZM25 22.2875C25.62 22.2875 26.12 22.7975 26.12 23.4075C26.12 24.0175 25.61 24.5275 25 24.5275C24.39 24.5275 23.88 24.0175 23.88 23.4075C23.88 22.7975 24.38 22.2875 25 22.2875ZM25 27.6575C24.07 27.6575 23.26 27.1975 22.76 26.4875C22.81 25.7675 24.27 25.4075 25 25.4075C25.73 25.4075 27.19 25.7675 27.24 26.4875C26.74 27.1975 25.93 27.6575 25 27.6575Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalChannelFilledIcon);
export default __webpack_public_path__ + "static/media/digital_channel_filled_icon.33645e77b064a1067dcd39fcce9f678d.svg";
export { ForwardRef as ReactComponent };